import React, { useState } from 'react';
import { CalendarOutlined } from '@ant-design/icons';
import RangeDatePicker from '../../form/basicFields/RangeDatePicker/RangeDatePicker';
import dayjs from 'dayjs';
import { Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { DATETIME_FORMAT_DATE } from '../../../../utils/helpers/CommonHelper.jsx';

export const useServerSideDateRangeFilter = (
  dataIndex,
  filters,
  setFilters,
) => {
  const [tempValue, setTempValue] = useState(null);
  const selectedFrom = filters[`${dataIndex}_from`] ?? null;
  const selectedTo = filters[`${dataIndex}_to`] ?? null;
  const { t } = useTranslation();
  return {
    filterDropdown: ({ confirm, clearFilters }) => (
      <div style={{ padding: 8, width: 300 }}>
        <RangeDatePicker
          size="large"
          value={tempValue}
          onChange={(dates) => {
            setTempValue(dates);
          }}
        />
        <Space style={{ marginTop: 8, justifyContent: 'end', display: 'flex' }}>
          <Button
            onClick={() => {
              setTempValue(null);
              const updated = { ...filters };
              delete updated[`${dataIndex}_from`];
              delete updated[`${dataIndex}_to`];
              setFilters(updated);
              confirm();
            }}
            size="small"
          >
            {t('Zrušiť')}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              if (!tempValue) return;
              const [from, to] = tempValue;
              setFilters({
                ...filters,
                [`${dataIndex}_from`]: dayjs(from).format('YYYY-MM-DD'),
                [`${dataIndex}_to`]: dayjs(to).format('YYYY-MM-DD'),
              });
              confirm();
            }}
            size="small"
          >
            {t('Potvrdiť')}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <CalendarOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    filteredValue:
      selectedFrom && selectedTo ? [`${selectedFrom}-${selectedTo}`] : null,
    filterValueFormatter: () =>
      `${dayjs(selectedFrom).format(DATETIME_FORMAT_DATE)} – ${dayjs(selectedTo).format(DATETIME_FORMAT_DATE)}`,
    onFilterClear: () => {
      setTempValue(null);
      const updated = { ...filters };
      delete updated[`${dataIndex}_from`];
      delete updated[`${dataIndex}_to`];
      setFilters(updated);
    },
  };
};
